__turbopack_context__.v({
  "banner": "XTLORq_banner",
  "col": "XTLORq_col",
  "img": "XTLORq_img",
  "sectionHeader": "XTLORq_sectionHeader",
  "subtitle": "XTLORq_subtitle",
  "title": "XTLORq_title",
  "top": "XTLORq_top",
  "top2": "XTLORq_top2",
  "wrapper": "XTLORq_wrapper",
});
